export enum EPlatformNoticeRecipientType {
  Restaurant = "Restaurant",
  Courier = "Courier",
  Reseller = "Reseller",
}
